import AlertTabs from "../components/Alerts/AlertTabs";
import ProjectSelector from "../components/Alerts/ProjectSelector";
import BreadCrumb from "../components/BreadCrumb";
import AlertList from "../components/Alerts/AlertList";
import { FiAlertOctagon } from "react-icons/fi";
import { getAllAlerts } from "../api/Api";
import { useState, useEffect } from "react";
import Box from "../components/ui/Box";


const AlertsPage = () => {
    const [selectedProject, setSelectedProject] = useState(null);
    const [activeTab, setActiveTab] = useState("All");
    const [alertsData, setAlertsData] = useState([]); 
  
     
   useEffect(() => {
    getAllAlerts().then((response) => {
        if (response.data) {
            setAlertsData(response.data);
        } else {
            setAlertsData([]);  
        }
    });
}, []);
  

         
    const filteredAlerts = alertsData.filter((alert) => {
        
        const matchesProject = selectedProject
            ? String(alert.context?.id) === String(selectedProject): true; 

        const matchesTab = activeTab === "All" ? true : `${alert.alert_type}s` === activeTab.toLowerCase()

        return matchesProject && matchesTab; 
    });

    const breadcrumbArray = [
        { title: "Alerts", link: "/alerts" },
    ];


    return (
        <Box innerClass="bg-white h-100" className="h-100">
            <BreadCrumb
                array={breadcrumbArray}
                icon={<FiAlertOctagon size={25} color={"#0BA7FF"} style={{ fill: 'none' }} />} 
               
            />

            <AlertTabs activeTab={activeTab} setActiveTab={setActiveTab} />
            <div className="mb-5 mt-4 mx-3 d-flex justify-content-end">
            <ProjectSelector setSelectedProject={setSelectedProject} />
            </div>
            <AlertList alerts={filteredAlerts} activeTab={activeTab} />
        </Box>
    );
};

export default AlertsPage;

